import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormHelper } from 'app/shared/services/form-helper.service';
import { SessionService } from 'app/shared/services/session.service';
import { TokenDataService } from 'app/shared/services/token-data.service';
import { UtilService } from 'app/shared/services/util.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { FileClaimTestData } from './nw-test-constant';
import { NwTestToolService } from './nw-test-tool-service';

interface EnvironmentVariable {
    environment: string;
    serverNumber: string;
}

interface BillingVariable {
    billingFlexRegion: string;
    billingBcRegion: string;
}
@Component({
    selector: 'is-nw-test-tool',
    templateUrl: './nw-test-tool.component.html',
    styleUrls: ['./nw-test-tool.component.scss'],
    standalone: false
})

export class NwTestToolComponent implements OnInit {
    /**
     * @description - nwToolBarIsDisplay; variable to show / hide the tool bar
     * @type boolean
     * @memberof NwTestToolComponent
    */
    nwToolBarIsDisplay = false;

    /**
     * @description - nwCloseCaption variable for the close button caption to the tool bar.
     * @type string
     * @memberof NwTestToolComponent
     */
    nwCloseCaption = '^';

    /**
     * @description - model - form model object to set environment variables
     * @type EnvironmentVariable
     * @memberof NwTestToolComponent
     */
    model: EnvironmentVariable = {
        environment: '',
        serverNumber: ''
    };

    awsmodel: any = {
        awsenv: ''
    };

    cddqmsModel: any = {
        cddqmsEnv: ''
    };

    billingModel: BillingVariable = {
        billingFlexRegion: '',
        billingBcRegion: ''
    };

    ignoreTest: any = {
        contact: false
    };

    fileClaimTestData = FileClaimTestData;
    /**
     * @description - environmentPickForm form group displaying environment and server number as input
     * @type FormGroup
     * @memberof NwTestToolComponent
     */
    public environmentPickForm!: UntypedFormGroup;
    awsenvironment: any;
    cddqmsEnvFG: any;
    billingTargetEnvFG: any;
    fileClaimTest!: UntypedFormGroup;
    ignoreTestData!: UntypedFormGroup;
    cddqmsPullRequests!: any[];
    token = environment.token;

    constructor (
        private fh: FormHelper,
        private utils: UtilService,
        private sessionService: SessionService,
        private testToolService: NwTestToolService,
        private tokenDataService: TokenDataService,
        private cookieService: CookieService) { }

    /**
     * @description - onLoad component, build the form and set the models.
     * @param none
     * @return none
     * @memberof NwTestToolComponent
     */
    ngOnInit(): any {
        this.getOpenPullRequestsFromGit();
        this.buildForm();
        this.setModel();
    }

    /**
     * @description - toggleToolBar - show / hide the tool bar
     * @param none
     * @return none
     * @memberof NwTestToolComponent
     */
    toggleToolBar(): any {
        this.nwToolBarIsDisplay = !this.nwToolBarIsDisplay;
        this.nwCloseCaption = (this.nwCloseCaption === 'X') ? '^' : 'X';
    }

    /**
     * @description - buildForm build form and set model
     * @param none
     * @return none
     * @memberof NwTestToolComponent
     */
    buildForm(): void {
        this.setModel();
        this.environmentPickForm = this.fh.build({
            environment: [this.model.environment, []],
            serverNumber: [this.model.serverNumber, []]
        });

        this.awsenvironment = this.fh.build({
            awsenv: [this.awsmodel.awsenv]
        });

        this.fileClaimTest = this.fh.build({
            users: []
        });

        this.ignoreTestData = this.fh.build({
            contact: [this.ignoreTest.contact, []]
        });

        this.cddqmsEnvFG = this.fh.build({
            cddqmsEnv: [this.cddqmsModel.cddqmsEnv]
        });

        this.billingTargetEnvFG = this.fh.build({
            billingFlexRegion: [this.billingModel.billingFlexRegion],
            billingBcRegion: [this.billingModel.billingBcRegion]
        });
    }

    /**
     * @description - setModel function to get the cookie values and set the model
     * @param none
     * @return none
     * @memberof NwTestToolComponent
     */
    setModel(): any {
        const envCookie = this.cookieService.get(environment.claimsCookies.claimsEnv);

        const envServerNo = this.cookieService.get(environment.claimsCookies.claimsEnvNumber);

        const envMSEnv = this.cookieService.get(environment.claimsCookies.cddqmsEnv) || environment.claims_digital_dynamic_questioning_env;
        this.cookieService.delete(environment.claimsCookies.cddqmsEnv);
        this.cookieService.set(environment.claimsCookies.cddqmsEnv, envMSEnv, environment.claimsCookies.cookieOptions);
        this.cddqmsModel.cddqmsEnv = envMSEnv;

        this.model = {
            environment: this.utils.isStrictNull(envCookie) ? environment.ClaimsEnvironment.envName : envCookie,
            serverNumber: this.utils.isStrictNull(envServerNo) ? environment.ClaimsEnvironment.serverId : envServerNo
        };

        this.awsmodel = {
            awsenv: this.cookieService.get(environment.claimsCookies.awsRouterIdentifier)
        };

        this.billingModel = {
            billingFlexRegion: this.cookieService.get(environment.claimsCookies.billingFlexRegion) || environment.BILLING?.FLEX_REGION || '.U080',
            billingBcRegion: this.cookieService.get(environment.claimsCookies.billingBcRegion) || environment.BILLING?.BC_REGION || 'QA'
        };

        const ignoreTestContact = this.sessionService.getSessionItemDecrypted('ignoreTestContact');
        const isEmptyObject = (obj: any): boolean => Object.keys(obj).length === 0 && obj.constructor === Object;
        this.ignoreTest = {
            contact: isEmptyObject(ignoreTestContact) ? false : ignoreTestContact
        };
    }

    /**
     * @description - setCookie set the cookie value read from model.
     * @param none
     * @return none
     * @memberof NwTestToolComponent
     */
    setCookie(): any {
        this.model = this.environmentPickForm.value;
        this.cookieService.delete(environment.claimsCookies.claimsEnv);
        this.cookieService.delete(environment.claimsCookies.claimsEnvNumber);
        this.cookieService.set(environment.claimsCookies.claimsEnv, this.model.environment, environment.claimsCookies.cookieOptions);
        this.cookieService.set(environment.claimsCookies.claimsEnvNumber, this.model.serverNumber, environment.claimsCookies.cookieOptions);
        this.reloadPage();
    }

    setIgnoreTestData(): void {
        this.ignoreTest.contact = this.ignoreTestData.controls.contact.value;
        this.sessionService.setSessionItem('ignoreTestContact', this.ignoreTest.contact);
        this.reloadPage();
    }

    setRouter(): any {
        this.awsmodel = this.awsenvironment.value;
        this.cookieService.delete(environment.claimsCookies.awsRouterIdentifier);
        this.cookieService.set(environment.claimsCookies.awsRouterIdentifier, this.awsmodel.awsenv, environment.claimsCookies.cookieOptions);
        this.reloadPage();
    }

    setFileClaimData(): void {
        if (this.fileClaimTest.controls.users.value !== null && this.fileClaimTest.controls.users.value !== '') {
            this.testToolService.setFileClaimData(this.fileClaimTest.controls.users.value);
        }
    }

    setMSCookie(): void {
        const cddqmsEnv = this.cddqmsEnvFG.value.cddqmsEnv.split(' ')[0];
        this.cookieService.delete(environment.claimsCookies.cddqmsEnv);
        this.cookieService.set(environment.claimsCookies.cddqmsEnv, cddqmsEnv, environment.claimsCookies.cookieOptions);
        this.highlightCddqmsEnvInput();
    }

    setBillingTargetEnv(): void {
        this.billingModel = this.billingTargetEnvFG.value;
        const billingFlexRegion = (this.billingModel.billingFlexRegion || '').trim();
        const billingBcRegion = (this.billingModel.billingBcRegion || '').trim();

        this.cookieService.delete(environment.claimsCookies.billingFlexRegion);
        this.cookieService.delete(environment.claimsCookies.billingBcRegion);

        if (billingFlexRegion) {
            this.cookieService.set(environment.claimsCookies.billingFlexRegion, billingFlexRegion, environment.claimsCookies.cookieOptions);
        }
        if (billingBcRegion) {
            this.cookieService.set(environment.claimsCookies.billingBcRegion, billingBcRegion, environment.claimsCookies.cookieOptions);
        }

        if (billingFlexRegion && billingBcRegion) {
            sessionStorage.setItem('targetEnvironment', `${billingFlexRegion}|${billingBcRegion}`);
        } else if (billingFlexRegion) {
            sessionStorage.setItem('targetEnvironment', billingFlexRegion);
        } else {
            sessionStorage.removeItem('targetEnvironment');
        }

        this.reloadPage();
    }

    private reloadPage(): void {
        window.location.reload();
    }

    highlightCddqmsEnvInput(): void {
        const select: HTMLSelectElement | null = document.querySelector('select[formcontrolname="cddqmsEnv"]');
        if (select) {
            const originalTransition = select.style.transition;
            const originalBg = select.style.backgroundColor;
            select.style.transition = 'background-color 0.5s';
            select.style.backgroundColor = '#c0f5ab';
            setTimeout(() => {
                select.style.backgroundColor = originalBg || '';
                setTimeout(() => {
                    select.style.transition = originalTransition || '';
                }, 500);
            }, 500);
        }
    }
    getOpenPullRequestsFromGit(): any {
        const gitPullRequests = 'https://api.github.com/repos/Nationwide/claims-digital-dynamic-questioning-service/pulls?state=open';
        fetch(gitPullRequests,
            {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }
        ).then((response) => response.json())
            .then((data) => {
                this.cddqmsPullRequests = ['dev', 'test'];
                if (data?.length > 0 ) {
                    data.forEach((pr: any) => {
                        const label = this.fetchLabel(pr);
                        this.cddqmsPullRequests.push(`pr-${pr.number} (${label})`);
                    });
                }
            });
    }

    fetchLabel(pr: any): any {
        if (pr && Array.isArray(pr.labels)) {
            const match = pr.labels.find((lbl: any) => typeof lbl?.name === 'string' && /^for\b/i.test(lbl.name));
            if (match) {
                return match.name.replace('for-', '').toUpperCase();
            }
        }
        return 'unknown';
    }
}
